import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import OnboardingDialog from './OnboardingDialog';
import { shouldOpenOnLaunch, useOnboardingStore } from './onboardingState';
import './onboarding.css';

/**
 * Mounted once by App. Opens the flow on a launch that needs it (terms not
 * accepted yet, or the tour never finished) and whenever Help → "Replay
 * onboarding" asks. The dialog is keyed on the open SESSION only, so a replay
 * starts fresh while nothing inside a session can re-mount it.
 */
export default function OnboardingHost() {
  const open = useOnboardingStore((s) => s.open);
  const session = useOnboardingStore((s) => s.session);
  const startAt = useOnboardingStore((s) => s.startAt);
  const closeOnboarding = useOnboardingStore((s) => s.closeOnboarding);

  useEffect(() => {
    if (shouldOpenOnLaunch()) useOnboardingStore.getState().openOnboarding('welcome');
  }, []);

  if (!open) return null;
  return createPortal(
    <OnboardingDialog key={session} startAt={startAt} onClose={closeOnboarding} />,
    document.body
  );
}
